/**
 * @voltxampere/ui — LM2596 buck switching regulator variant (Sprint 42-2)
 *
 * Adjustable TO-220 buck regulator, V_in 4.5-40 V, V_out adjustable
 * 1.23-37 V (default 5 V), I_out 3 A. The Sprint 4 vdc stamp
 * idealizes the output as a clean voltage source — the user reads
 * the V_out setpoint from the Inspector card; PWM ripple +
 * efficiency are model-layer metadata and not simulated this
 * sprint. Real switching simulation lands Sprint 50+ per ADR-0061
 * §"Future work catalogued".
 *
 * Reference: TI LM2596. Engine zero-diff invariant honored —
 * canonical "voltage-source" engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const regulatorLm2596 = {
    id: "lm2596",
    nameTr: "LM2596 (Buck Anahtarlamalı +5V, TO-220)",
    nameEn: "LM2596 (Buck Switching +5V, TO-220)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "LM2596",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=regulator-lm2596.js.map